import { render } from "./UIUXWork.vue?vue&type=template&id=9b64650e&scoped=true"
import script from "./UIUXWork.vue?vue&type=script&lang=js"
export * from "./UIUXWork.vue?vue&type=script&lang=js"

import "./UIUXWork.vue?vue&type=style&index=0&id=9b64650e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b64650e"]])

export default __exports__